import { ChakraTheme } from '@chakra-ui/theme';
import { baseDark } from './colors/baseDark';
import { baseLight } from './colors/baseLight';
import { baseTextStyles } from './textStyles';
import { baseButtons } from './buttons';
import { baseShadows } from './shadows';
export const baseTheme = (colorMode: 'light' | 'dark'): Partial<ChakraTheme> => ({
  styles: {
    global: {
      html: {},
      body: {      
        color: '#ffffff',
        backgroundColor: 'rgba(5, 5, 5, 1)',
        // background: `
        //   radial-gradient(
        //     circle at 30% 30%,
        //     rgba(255, 255, 255, 0.05) 0%,
        //     transparent 20%
        //   ),
        //   radial-gradient(
        //     circle at 70% 70%,
        //     rgba(255, 255, 255, 0.05) 0%,
        //     transparent 20%
        //   )`, 
      },
    },
  },  fonts: {
  },
  colors: colorMode === 'light' ? baseLight : baseDark,
  shadows: colorMode === 'light' ? baseShadows.light : baseShadows.dark, 
  textStyles: baseTextStyles,
  components: {
    Button: {
      ...baseButtons, 
      variants: {
        ...baseButtons.variants, 
      },
    },
  },
})

// #0F101B